import { type FC, memo } from 'react';

export type CloudSubnetDetailData = {
  cloudProvider: string | null;
  subnetId: string | null;
  cloudNetworkId: string | null;
  name: string | null;
  availabilityZone: string | null;
  region: string | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudSubnetDetailData;
}

const BareCloudSubnetDetailContent: FC<Props> = (props) => {
  const cloudProvider = props.tableData.cloudProvider?.toLowerCase();
  return (
    <table className={props.tableClassName}>
      <tbody>
        <tr>
          <td className={props.firstColumnClassName}>Cloud provider</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudProvider}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Subnet ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.subnetId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Cloud network ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudNetworkId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Name</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.name}
          </td>
        </tr>
        {cloudProvider === 'aws' && (
          <tr>
            <td className={props.firstColumnClassName}>Availability zone</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.availabilityZone}
            </td>
          </tr>
        )}
        {cloudProvider === 'gcp' && (
          <tr>
            <td className={props.firstColumnClassName}>Region</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.region}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export const CloudSubnetDetailContent = memo(BareCloudSubnetDetailContent);
